import { isIpac } from '@config/constants';
import {
  EcoleFrancaiseLogoDiv,
  IPacLogoDiv,
  MultiSitesDiv,
} from './DisplayLogo.styled';
import LogoHorizontal from './LogoHorizontal';
import LogoIPacOnline from './LogoIPacOnline';
import LogoMultiSites from './LogoMultiSites';

const multiSitesConfig = [
  // --- A dé-commenter si besoin de tester le logo d'un multi-site
  // { hostname: 'form-react.ecolefrancaise.dev', url: 'https://formation-assistante-ressources-humaines.fr', title: 'Assistante ressources humaines', twoLines: true },
  {
    hostname: 'formations-secretaire-medicale.fr',
    url: 'https://formations-secretaire-medicale.fr',
    title: 'Secrétaire médicale',
    twoLines: true,
  },
  {
    hostname: 'formation-decoration-interieur.fr',
    url: 'https://formation-decoration-interieur.fr',
    title: "Décoration d'intérieur",
    twoLines: true,
  },
  {
    hostname: 'se-former-en-ligne.fr',
    url: 'https://se-former-en-ligne.fr',
    title: 'Se former en ligne',
  },
  {
    hostname: 'formation-nutrition-dietetique.fr',
    url: 'https://formation-nutrition-dietetique.fr',
    title: 'Nutrition diététique',
    twoLines: true,
  },
  {
    hostname: 'formation-cpf-en-ligne.fr',
    url: 'https://formation-cpf-en-ligne.fr',
    title: 'Se Former',
  },
  {
    hostname: 'formations-marketing-en-ligne.fr',
    url: 'https://formations-marketing-en-ligne.fr',
    title: 'Marketing en ligne',
    twoLines: true,
  },
  {
    hostname: 'formations-compta.fr',
    url: 'https://formations-compta.fr',
    title: 'Formation Compta',
  },
  {
    hostname: 'formations-rh.fr',
    url: 'https://formations-rh.fr',
    title: 'Formation RH',
  },
  {
    hostname: 'formation-gestion-paie.fr',
    url: 'https://formation-gestion-paie.fr',
    title: 'Gestion de paie',
    twoLines: true,
  },
  {
    hostname: 'formation-chef-projet-evenementiel.fr',
    url: 'https://formation-chef-projet-evenementiel.fr',
    title: 'Chef de projet événementiel',
    twoLines: true,
  },
  {
    hostname: 'formation-filmer-monter-video.fr',
    url: 'https://formation-filmer-monter-video.fr',
    title: 'Filmer et monter des vidéos',
    twoLines: true,
  },
  {
    hostname: 'formation-creer-site-internet.fr',
    url: 'https://formation-creer-site-internet.fr',
    title: 'Créer un site internet',
    twoLines: true,
  },
  {
    hostname: 'petite-enfance-cap.fr',
    url: 'https://petite-enfance-cap.fr',
    title: 'CAP Petite enfance',
  },
  {
    hostname: 'esthetique-cap.fr',
    url: 'https://esthetique-cap.fr',
    title: 'CAP Esthétique',
  },
  {
    hostname: 'formation-creer-entreprise.fr',
    url: 'https://formation-creer-entreprise.fr',
    title: 'Créer une entreprise',
    twoLines: true,
  },
  {
    hostname: 'formation-assistante-direction.fr',
    url: 'https://formation-assistante-direction.fr',
    title: 'Assistante de direction',
    twoLines: true,
  },
  {
    hostname: 'excel-formations.com',
    url: 'https://excel-formations.com',
    title: 'Formation Excel',
  },
  {
    hostname: 'formation-marketing-en-ligne.fr',
    url: 'https://formation-marketing-en-ligne.fr',
    title: 'Marketing en ligne',
    twoLines: true,
  },
  {
    hostname: 'formation-nutrition.com',
    url: 'https://formation-nutrition.com',
    title: 'Formation Nutrition',
  },
  {
    hostname: 'formations-comptabilite-en-ligne.fr',
    url: 'https://formations-comptabilite-en-ligne.fr',
    title: 'Formation Comptabilité',
  },
  {
    hostname: 'formation-rh.fr',
    url: 'https://formation-rh.fr',
    title: 'Formation RH',
  },
  {
    hostname: 'formations-ressources-humaines.com',
    url: 'https://formations-ressources-humaines.com',
    title: 'Formation Ressources humaines',
  },
  {
    hostname: 'ressources-humaines-bachelor.fr',
    url: 'https://ressources-humaines-bachelor.fr',
    title: 'Bachelor Ressources humaines',
    twoLines: true,
  },
  {
    hostname: 'formation-comptable-entreprise.fr',
    url: 'https://formation-comptable-entreprise.fr',
    title: "Comptable d'entreprise",
    twoLines: true,
  },
  {
    hostname: 'formation-patrimoine.fr',
    url: 'https://formation-patrimoine.fr',
    title: 'Formation Patrimoine',
  },
  {
    hostname: 'photoshop-formation.fr',
    url: 'https://photoshop-formation.fr',
    title: 'Formation Photoshop',
  },
  {
    hostname: 'formations-eloquence.fr',
    url: 'https://formations-eloquence.fr',
    title: 'Formation Eloquence',
  },
  {
    hostname: 'formation-manager-equipes.fr',
    url: 'https://formation-manager-equipes.fr',
    title: 'Manager ses équipes',
    twoLines: true,
  },
  {
    hostname: 'reseaux-sociaux-formation.fr',
    url: 'https://reseaux-sociaux-formation.fr',
    title: 'Réseaux sociaux',
    twoLines: true,
  },
  {
    hostname: 'formation-prothesie-ongulaire.fr',
    url: 'https://formation-prothesie-ongulaire.fr',
    title: 'Prothésie ongulaire',
    twoLines: true,
  },
  {
    hostname: 'formation-langue-des-signes.fr',
    url: 'https://formation-langue-des-signes.fr',
    title: 'Langue des signes',
    twoLines: true,
  },
  {
    hostname: 'formations-secretariat.com',
    url: 'https://formations-secretariat.com',
    title: 'Formation Secrétariat',
  },
  {
    hostname: 'formation-bts-mco.fr',
    url: 'https://formation-bts-mco.fr',
    title: 'BTS MCO',
  },
  {
    hostname: 'mba-ressources-humaines.fr',
    url: 'https://mba-ressources-humaines.fr',
    title: 'MBA Ressources humaines',
  },
  {
    hostname: 'marketing-digital-formations.fr',
    url: 'https://marketing-digital-formations.fr',
    title: 'Marketing et digital',
    twoLines: true,
  },
  {
    hostname: 'formations-assistante-juridique.fr',
    url: 'https://formations-assistante-juridique.fr',
    title: 'Assistante juridique',
    twoLines: true,
  },
  {
    hostname: 'assistante-commercial-formations.fr',
    url: 'https://assistante-commercial-formations.fr',
    title: 'Assistante commerciale',
    twoLines: true,
  },
  {
    hostname: 'formation-assistante-ressources-humaines.fr',
    url: 'https://formation-assistante-ressources-humaines.fr',
    title: 'Assistante ressources humaines',
    twoLines: true,
  },
];

const DisplayLogo = () => {
  const hostname = window.location.hostname;

  if (isIpac) {
    return (
      <IPacLogoDiv
        onClick={() => window.open('https://www.ipac-online.com/', '_top')}
      >
        {LogoIPacOnline}
      </IPacLogoDiv>
    );
  }

  const siteConfig = multiSitesConfig.find(
    (site) => site.hostname === hostname,
  );

  if (siteConfig) {
    return (
      <MultiSitesDiv onClick={() => window.open(siteConfig.url, '_top')}>
        <LogoMultiSites
          title={siteConfig.title}
          twoLines={siteConfig.twoLines}
        />
      </MultiSitesDiv>
    );
  }

  return (
    <EcoleFrancaiseLogoDiv
      onClick={() => window.open('https://lecolefrancaise.fr', '_top')}
    >
      {LogoHorizontal}
    </EcoleFrancaiseLogoDiv>
  );
};

export default DisplayLogo;
